import { useEffect } from "react";
import { clearClientSession } from "../../../config/cookieUtils";
import helpherClass from "../../../config/helperClass";

const auth = new helpherClass();

// A REAL logout page, unlike /client/login (which does nothing to an
// already-valid session - visiting it can just bounce straight back to the
// dashboard). Exists so VA has somewhere to send the browser on logout that
// actually ends the OBS session too (api_keys.js's client_va_launch builds
// this exact path as logout_url). No backend call - clearClientSession()
// only touches cookies/localStorage, same as a normal logout button click.
// Lands on "/<reseller>" (the reseller login page) directly, same as the
// portal's own Logout button (helperClass.clientLogoutAction) - no extra hop
// through /client/login. Bare /logout falls back to the reseller cookie,
// read before clearClientSession() wipes it.
export default function ClientLogout(props) {
  useEffect(() => {
    const reseller_url = props.match.params.reseller_url || auth.getResellerRegToken() || "";
    clearClientSession();
    window.location.replace("/" + reseller_url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
